import { watch, ref } from 'vue';
import { useLoggingStore } from 'src/stores/logging';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { axiosCallerPlugin } from 'src/plugins/axios/componentAxiosCallerPlugin';
import { ChatMiscDataPlugin } from 'src/features/messaging/chat/components/methods/misc';
/**
 * Plugin to query for host contact information
 * if host has indicated ok to share
 * when there are approved bookings
 */
const ChatHostInfoPlugin = () => {
    const hostContact = ref(null);
    const loggingStore = useLoggingStore();
    const { convo, isChatUser, } = ChatMiscDataPlugin();
    const { axiosCall } = axiosCallerPlugin();
    // query for host contact info
    const { subject: queryInfo$ } = rxInitSubjectCallback();
    useObservable(queryInfo$.pipe(switchMap((convoId) => {
        return of('').pipe(switchMap(() => {
            // query backend for the info in the convo
            return axiosCall({
                type: 'create',
                loading: false,
                data: {
                    firebase_chat_id_list: [convoId],
                },
                url: 'chat_room/inbox_info',
                urlType: 'chat',
                state: 'chatInfoData',
            });
        }), catchError((err) => {
            loggingStore.errorHandler(err);
            return of({ success: false, data: null });
        }), filter((v) => v.success), filter(({ data }) => data !== null), map(({ data }) => data), map(({ results }) => results), filter((data) => data.length > 0), map((data) => data[0]), filter((v) => v.host_contact_detail.host_contact_num !== null && (v.host_contact_detail.host_contact_num_country_code !== null)), tap((v) => {
            hostContact.value = v.host_contact_detail;
        }));
    })));
    watch(convo, (newValue) => {
        if (!newValue)
            return;
        if (!newValue.id)
            return;
        if (!isChatUser.value)
            return;
        queryInfo$.next(newValue.id);
    }, { immediate: true });
    return {
        hostContact
    };
};
export { ChatHostInfoPlugin };
